import {TemplateType} from "@dv5/domain"
import {formatDate, formatDateTime, addDays} from './dateUtils'

class TemplateService {
    getTitle(templateType: TemplateType): string {
        switch (templateType) {
            case TemplateType.DOCUMENT:
                return 'Document'
            case TemplateType.CANVAS:
                return 'Canvas'
            case TemplateType.DOCUMENT_PART:
                return 'Document Part'
            case TemplateType.CANVAS_WIDGETS:
                return 'Canvas Widgets'
            case TemplateType.TASK:
                return 'Task'
        }
        return 'Unknown'
    }
}

export const templateService = new TemplateService()

const placeholderRegex = /\{\{(\w+)\}\}/g

export function extractPlaceholders(data: unknown): string[] {
    const names: string[] = []

    function walk(value: unknown) {
        if (typeof value === 'string') {
            let match
            while ((match = placeholderRegex.exec(value)) !== null) {
                if (!names.includes(match[1])) {
                    names.push(match[1])
                }
            }
        } else if (Array.isArray(value)) {
            value.forEach(walk)
        } else if (value !== null && typeof value === 'object') {
            for (const v of Object.values(value as Record<string, unknown>)) {
                walk(v)
            }
        }
    }

    walk(data)
    return names
}

export const PLACEHOLDER_DESCRIPTIONS: Record<string, string> = {
    today: 'Current date',
    currentDate: 'Current date',
    currentDateTime: 'Current date and time',
    now: 'Current date and time',
    tomorrow: "Tomorrow's date",
    yesterday: "Yesterday's date",
}

export function getPlaceholderDefaults(now: Date = new Date()): Record<string, string> {
    return {
        today: formatDate(now),
        currentDate: formatDate(now),
        currentDateTime: formatDateTime(now),
        now: formatDateTime(now),
        tomorrow: formatDate(addDays(now, 1)),
        yesterday: formatDate(addDays(now, -1)),
    }
}

export interface PlaceholderInfo {
    name: string
    description: string
    value: string
    present: boolean
}

export function getAllPlaceholderInfo(data: unknown, now: Date = new Date()): PlaceholderInfo[] {
    const defaults = getPlaceholderDefaults(now)
    const used = new Set(extractPlaceholders(data))
    return Object.keys(PLACEHOLDER_DESCRIPTIONS).map(name => ({
        name,
        description: PLACEHOLDER_DESCRIPTIONS[name],
        value: defaults[name] ?? '',
        present: used.has(name),
    }))
}
